import {
  FETCH_FORM,
  FETCH_FORM_FULFILLED,
  FETCH_FORM_REJECTED,
  SUBMIT_FORM,
  SUBMIT_FORM_FULFILLED,
  SUBMIT_FORM_REJECTED,
} from 'b2b-apps/shop/content/redux/forms/actionTypes';
import {
  FetchFormAction,
  FetchFormFulfilledAction,
  FetchFormRejectedAction,
  FormDataType,
  FormElementType,
  SubmitFormAction,
  SubmitFormFulfilledAction,
  SubmitFormRejectedAction,
} from 'b2b-apps/shop/content/redux/forms/types';

const fetchForm = (formId: string): FetchFormAction => ({
  type: FETCH_FORM,
  payload: {
    formId,
  },
});

const fetchFormFulfilled = (
  formId: string,
  response: FormElementType[],
): FetchFormFulfilledAction => ({
  type: FETCH_FORM_FULFILLED,
  payload: {
    elements: response,
    formId,
  },
});

const fetchFormRejected = (
  formId: string,
  error: ErrorType,
): FetchFormRejectedAction => ({
  type: FETCH_FORM_REJECTED,
  payload: {
    error,
    formId,
  },
});

const submitForm = (
  formId: string,
  data: FormDataType,
): SubmitFormAction => ({
  type: SUBMIT_FORM,
  payload: {
    data,
    formId,
  },
});

const submitFormFulfilled = (formId: string): SubmitFormFulfilledAction => ({
  type: SUBMIT_FORM_FULFILLED,
  payload: {
    formId,
  },
});

const submitFormRejected = (
  formId: string,
  error: ErrorType,
): SubmitFormRejectedAction => ({
  type: SUBMIT_FORM_REJECTED,
  payload: {
    error,
    formId,
  },
});

export {
  fetchForm,
  fetchFormFulfilled,
  fetchFormRejected,
  submitForm,
  submitFormFulfilled,
  submitFormRejected,
};
